import FormHelperText from "@material-ui/core/FormHelperText/FormHelperText";
import React from "react";
import { hasMinimalDaysError, isDateInvalid, isDateOutsideRange, isDateInPastMonths, isDateMonthValid } from "../../../../utilities/dateTimeUtils";

export const minimalDaysError = (minimalDays: number, noFiles: number) => {
    return hasMinimalDaysError(minimalDays, noFiles) ? (
        <FormHelperText error={true}>{`Please select at least ${minimalDays} business days.`}</FormHelperText>
    ) : null;
};

export const filesEmptyError = (noFiles: number) => {
    return noFiles === 0 ? <FormHelperText error={true}>Selected date range contains no files.</FormHelperText> : null;
};

export const dateInvalidError = (from: string, to: string) => {
    return isDateInvalid(from, to) ? (
        <FormHelperText error={true}>Please select a date range where from is not after to.</FormHelperText>
    ) : null;
};

export const dateInPastMonthError = (date: string) => {
    return isDateInPastMonths(date) ? (
        <FormHelperText error={true}>Please select a date that is not in the past.</FormHelperText>
    ) : null;
};

export const dateMonthInvalidError = (date: string) => {
    return !isDateMonthValid(date) ? (
        <FormHelperText error={true}>Please enter a valid date.</FormHelperText>
    ) : null;
};

export const dateOutsideRangeError = (
    from: string,
    to: string,
    firstAvailableDate: string,
    lastAvailableDate: string
) => {
    return isDateOutsideRange(from, to, firstAvailableDate, lastAvailableDate) ? (
        <FormHelperText
            error={true}
        >{`Please select a date range between ${firstAvailableDate} and ${lastAvailableDate}.`}</FormHelperText>
    ) : null;
};

export const isNothingSelected = (noSelected: number): boolean => {
    return noSelected === 0;
};

export const isNoUserSelected = (userId: string): boolean => {
    return userId === null || userId.length === 0;
};

export const noUserSelectedError = (userId: string) => {
    return isNoUserSelected(userId) ? (
        <FormHelperText error={true}>No user is selected, please select a user.</FormHelperText>
    ) : null;
};

export const noSelectionError = (noSelected: number) => {
    return isNothingSelected(noSelected) ? (
        <FormHelperText error={true}>Nothing is selected, please select at least one asset.</FormHelperText>
    ) : null;
};

export const isMaxBaseCurrenciesReached = (noSelected: number, maxSelection: number): boolean => {
    return noSelected > maxSelection;
}

export const maxSelectionError = (noSelected: number, maxSelection: number) => {
    return isMaxBaseCurrenciesReached(noSelected, maxSelection) ? (
        <FormHelperText error={true}>{`You have selected ${noSelected} items, maximum allowed number is ${maxSelection}.`}</FormHelperText>
    ) : null;
};
